import { api } from "../../services";
import { uiActions } from "../ui";

import {
  REQUEST_CROPS,
  RECIEVE_CROPS,
  SET_SELECT_SEASON,
  SET_SELECT_CROP
} from "./types";

export const requestCrops = () => dispatch => {
  dispatch(uiActions.setLoading(true));
  dispatch({ type: REQUEST_CROPS });
  return api
    .getCrops()
    .then(crops => {
      dispatch(uiActions.setLoading(false));
      dispatch(recieveCrops(crops));
    })
    .catch(e => {
      dispatch(uiActions.setLoading(false));
      dispatch(uiActions.showMessage("Kunde inte hämta grödor"));
    });
};

const recieveCrops = crops => {
  return {
    type: RECIEVE_CROPS,
    payload: crops
  };
};

export const changeSelectedCrop = id => {
  return {
    type: SET_SELECT_CROP,
    payload: id
  };
};

export const changeSelectedSeason = id => {
  return {
    type: SET_SELECT_SEASON,
    payload: id
  };
};
